import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { loadFonts } from "./plugins/webfontloader";
import { createMetaManager, plugin as metaPlugin } from "vue-meta";

loadFonts();

createApp(App)
  .use(vuetify)
  .use(store)
  .use(router)
  .use(createMetaManager())
  .use(metaPlugin)
  .mount("#app");
